import { TimeOnly } from "../@client/System"

export function mantineTimeToTimeOnly(v: string): TimeOnly {
  if (v === "") return "00:00" as TimeOnly
  if (v.length === 8) {
    return v as TimeOnly
  }
  if (v.length === 5) {
    return (v + ":00") as TimeOnly
  } else {
    throw new Error("unexpected time length")
  }
}
